import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext.jsx';
import { ToastProvider } from './context/ToastContext.jsx';
import ProtectedRoute from './components/ProtectedRoute.jsx';
import LoginPage from './pages/LoginPage.jsx';
import OverviewPage from './pages/OverviewPage.jsx';
import PublishersPage from './pages/PublishersPage.jsx';
import PublisherDetailPage from './pages/PublisherDetailPage.jsx';
import DemandPartnersPage from './pages/DemandPartnersPage.jsx';
import PartnerOnboardingPage from './pages/PartnerOnboardingPage.jsx';
import InboundSeatsPage from './pages/InboundSeatsPage.jsx';
import QpsPage from './pages/QpsPage.jsx';
import ReportingFeedsPage from './pages/ReportingFeedsPage.jsx';
import SeatDetailPage from './pages/SeatDetailPage.jsx';
import SeatBundleFloorsPage from './pages/SeatBundleFloorsPage.jsx';
import SupplyQualityPage from './pages/SupplyQualityPage.jsx';
import DiagnosticsPage from './pages/DiagnosticsPage.jsx';
import AuditLogPage from './pages/AuditLogPage.jsx';
import AuctionLogPage from './pages/AuctionLogPage.jsx';
import TeamPage from './pages/TeamPage.jsx';

export default function App() {
  return (
    <ToastProvider>
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/login" element={<LoginPage />} />
            <Route element={<ProtectedRoute />}>
              <Route path="/" element={<OverviewPage />} />
              <Route path="/publishers" element={<PublishersPage />} />
              <Route path="/publishers/:id" element={<PublisherDetailPage />} />
              <Route path="/demand-partners" element={<DemandPartnersPage />} />
              {/* Migrations 039 + 074: the onboarding workflow, in the console instead of curl. */}
              <Route path="/demand-partners/:code/onboarding" element={<PartnerOnboardingPage />} />
              <Route path="/inbound-seats" element={<InboundSeatsPage />} />
              {/* Migrations 069 + 070: QPS governance, operable instead of curl-only. */}
              <Route path="/traffic-controls" element={<QpsPage />} />
              {/* Migration 071: reporting import freshness, sync runs, flagged revisions. */}
              <Route path="/reporting-feeds" element={<ReportingFeedsPage />} />
              <Route path="/inbound-seats/:seatId" element={<SeatDetailPage />} />
              <Route path="/inbound-seats/:seatId/bundle-floors" element={<SeatBundleFloorsPage />} />
              <Route path="/supply-quality" element={<SupplyQualityPage />} />
              <Route path="/diagnostics" element={<DiagnosticsPage />} />
              <Route path="/audit-log" element={<AuditLogPage />} />
              <Route path="/auction-log" element={<AuctionLogPage />} />
              <Route path="/team" element={<TeamPage />} />
            </Route>
          </Routes>
        </BrowserRouter>
      </AuthProvider>
    </ToastProvider>
  );
}
